import React, { ReactNode } from 'react'
import { Box, Box as CustomerInfoBox, Box as CustomerWalletsBox } from '@node-space/ui-components'

export interface CustomerLayoutProps {
  CustomerWallets: ReactNode
  CustomerInfo: ReactNode
}

export const CustomerLayout = ({ CustomerWallets, CustomerInfo }: CustomerLayoutProps) => {
  return (
    <Box flexCol gap={24} width="full" justify="center" className="md:flex-row">
      <CustomerWalletsBox flexCol className="md:w-2/3 break-words">
        {CustomerWallets}
      </CustomerWalletsBox>
      <CustomerInfoBox flexCol className="md:w-1/3">
        {CustomerInfo}
      </CustomerInfoBox>
    </Box>
  )
}
